import styled, { css } from 'styled-components';
import theme from 'src/theme';

export const OperationListMainWrapper = styled.div`
    height: 100%;
    width: 100%;
`;

export const OperationListFilterBarStyle = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    overflow: hidden;

    padding: 5px 10px;
    background: ${theme.colors.background.white};
    font-weight: 600;

    .left-wrapper {
        gap: 15px;
        display: flex;
        margin: 10px 0 0 0;
        font-size: 0.95rem;
    }

    .right-wrapper {
        gap: 5px;
        display: flex;

        .select-violation-status label select {
            font-size: 0.7rem;
            font-weight: 600;
            line-height: 1.2rem;
        }
    }

    .second-filter {
        margin: 0 20px 0 0;
    }
`;

export const VerticalSeparator = styled.div`
    border-left: 1px solid ${theme.colors.border.mediumGrey};
    height: 1.2rem;
    margin: 0 5px;
    align-self: center;
    width: 1px;
    flex: 0 0 0;
`;

export const OperationListStyle = styled.div`
    background: ${theme.colors.background.white};
    height: 100%;
    overflow-y: auto;
    position: relative;
    scrollbar-gutter: stable;
    padding-top: 30px;
    outline: none;
    .operation-list-menu {
        background: ${theme.colors.background.transparent};
        display: flex;
    }
    .transit-op {
        padding: 5px;
        margin: 5px;
        font-style: italic;
        font-weight: 600;
        font-size: 0.8rem;
    }
`;

export const BerthOperations = styled.ul`
    padding: 3px 0;
    .berth-name {
        font-weight: 600;
        padding: 3px;
        display: block;
        border-bottom: 1px solid ${theme.colors.border.lightGrey};
        margin: 0 0 5px;
        font-size: 0.8rem;
        box-shadow: ${theme.colors.shadow.lightGrey} 0px 2px 3px -1px;
    }
`;

const OperationListItemGeneralStyle = css`
    display: flex;
    align-items: center;
    cursor: pointer;
    position: relative;
    border: 1px solid transparent;
    width: 100%;

    &:hover .col {
        background: ${theme.colors.background.hover.default};
        &.warning {
            background: ${theme.colors.background.warning};
        }
    }

    .col {
        position: relative;
    }

    .sort-icon {
        font-size: 0.65rem;
        margin: 0 2px;
    }
`;

export const OperationListItemStyle = styled.li`
    &.selected-operation {
        background: ${theme.legacyColors.selectedBackground};

        .col {
            border: 1px solid ${theme.colors.border.opertionList};
        }
    }

    .operation-list-item-content {
        ${OperationListItemGeneralStyle}
    }
`;

export const OperationListHeaderStyle = styled.div`
    ${OperationListItemGeneralStyle}
    font-weight: 500;
    font-size: 0.8rem;
    position: sticky;
    top: -31px;
    width: 100%;
    z-index: 2;
    margin-top: -31px;
    background: ${theme.colors.background.white};

    .col {
        border: 1px solid ${theme.colors.border.lightGrey};
        text-align: center;
        background: ${theme.colors.background.header};
        font-size: 0.75rem;
    }
`;

export const OperationStatusIconsWrapper = styled.div`
    display: grid;
    gap: 2px;
    width: 100%;
    align-items: center;
    grid-template-columns: 20px 16px 16px 16px 16px 16px 16px;

    .status-icon-column {
    }

    .manual-node-marker {
        font-size: 0.5rem;
        font-weight: 600;
        width: 13px;
        background: ${theme.colors.background.manualNode};
        border-radius: 50%;
        text-align: center;
        color: ${theme.colors.background.white};
        height: 13px;
        display: flex;
        justify-content: center;
        align-items: center;
    }
`;

export const ExpandOperationList = styled.button`
    background: none;
    border: 1px solid transparent;
    font-size: 0.8rem;
    cursor: pointer;
`;

export const ColumnMenuButton = styled.button<{ isActive?: boolean }>`
    background: ${({ isActive }) => (isActive ? theme.legacyColors.selectedBackground : theme.colors.background.menu.default)};
    border: 1px solid ${theme.colors.border.mediumGrey};
    font-size: 0.9rem;
    padding: 0.25rem;
    height: 1.25rem;
    margin: 0 5px;
    display: flex;
    align-items: center;
    font-weight: 600;
    cursor: pointer;
    border-radius: 4px;
    box-shadow: ${theme.colors.shadow.mediumGrey} 0px 2px 8px -1px;
`;

export const DefaultSortButton = styled.button<{ isActive?: boolean }>`
    background: ${({ isActive }) => (isActive ? theme.legacyColors.selectedBackground : theme.colors.background.menu.default)};
    border: 1px solid ${theme.colors.border.mediumGrey};
    font-size: 0.9rem;
    padding: 0.25rem;
    height: 1.25rem;
    margin: 0 5px;
    display: flex;
    align-items: center;
    font-weight: 600;
    cursor: pointer;
    border-radius: 4px;
    box-shadow: ${theme.colors.shadow.mediumGrey} 0px 2px 8px -1px;
    position: relative;
    width: 50px;
`;

export const OperationMenuWrapper = styled.div`
    width: 100%;
    height: 5px;
    position: relative;
`;

export const ColumnResizer = styled.div`
    width: 10px;
    height: 100%;
    position: absolute;
    right: -5px;
    top: 0;
    cursor: col-resize;
    z-index: 30;
    user-select: none;

    &:after {
        content: '';
        position: absolute;
        top: 0;
        bottom: 0;
        left: 50%;
        width: 2px;
        background-color: transparent;
    }

    &:hover:after,
    &.resizing:after {
        background-color: ${theme.colors.border.portCall};
    }
`;

export const ColumnContainer = styled.span<{ width?: string; isActive?: boolean }>`
    position: relative;
    border: 1px solid ${theme.colors.border.lightGrey};
    min-width: 80px;
    font-size: 0.8rem;
    text-align: center;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    height: 1.6rem;
    padding: 2px 4px;
    box-sizing: border-box;
    background: ${({ isActive }) => (isActive ? `${theme.legacyColors.selectedBackground} !important` : 'transparent')};

    /* Handle both flex values and pixel widths for compatibility */
    ${(props) => {
        if (!props.width) return 'flex: 1 1 0;';

        // If it's a pixel value, use it as flex-basis
        if (props.width.endsWith('px')) {
            return `flex: 0 0 ${props.width};`;
        }

        // Otherwise treat as flex-grow value
        return `flex: ${props.width} 1 0;`;
    }}

    /* Restore specific column styles */
    &.col-menu {
        min-width: 135px;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: flex-start;
        gap: 5px;
        padding: 0 5px;
    }

    &.col-cargo-nr {
        min-width: 105px;
    }

    &.col-right {
        text-align: right;
    }

    /* Ensure the header items have the proper background and centered text - higher specificity */
    .operation-list-header &,
    .operation-list-header &.col-right,
    .operation-list-header &.col-nom {
        border: 1px solid ${theme.colors.border.mediumGrey};
        background: ${theme.colors.background.header};
        text-align: center !important;
    }

    /* Align text to the left for specific columns in content rows only */
    .operation-list-item-content &.col-trade-name,
    .operation-list-item-content &.col-ports,
    .operation-list-item-content &.text-left {
        text-align: left;
        padding-left: 8px;
    }

    &.highlight {
        font-weight: 600;
    }
    &.warning {
        background: ${theme.colors.background.warning};
    }

    /* Remove the background from columns when row is selected to avoid double highlighting */
    .selected-operation {
        .col {
            background: transparent;
        }
    }

    &.dragging {
        opacity: 0.5;
        border: 1px dashed ${theme.colors.border.portCall};
    }

    &.dragging-over {
        border-left: 2px solid ${theme.colors.border.portCall};
    }
`;

// Add specific styling for the buttons container to ensure proper display
export const HeaderButtonsContainer = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 5px;
`;
